import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const withAuthGuard = (WrappedComponent: React.FC) => {
  return (props: any) => {
    const { user, loading, userSetupCompleted } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      if (!loading) {
        if (!user) {
          navigate("/auth"); // 未ログインの場合
        } else if (userSetupCompleted === false) {
          navigate("/user-setup"); // 基本情報未登録の場合
        }
      }
    }, [user, loading, userSetupCompleted, navigate]);

    if (loading) {
      return <p>読み込み中...</p>;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withAuthGuard;
